module.exports = __webpack_public_path__ + "brokerTours-90ef4911.svg";